import { getDebugLogger, getInfoLogger, normalizeSlashChars } from '@ori/checkout-utils';
import { parseSpaConfig } from '@ori-appshell/config';

import { APP_NAME } from '../constants';
import type { AppConfig, ParsedConfigData, RequiredConfigProps, ToIndexed } from '../types';

const logDebug = getDebugLogger(APP_NAME);
const logInfo = getInfoLogger(APP_NAME);

// Required props for parseSpaConfig method.
const requiredProps: RequiredConfigProps<AppConfig> = [
  'currentLanguage',
  'customerId',
  'identityUrl',
  'staticApiUrl',
  'tenant',
];

/**
 * Normalizes some values in the raw parsed config.
 * @param parsedConfig Original config data returned by the parseSpaConfig method.
 * @returns Final normalized configuration.
 */
export const normalizeConfigData = <T extends ParsedConfigData<AppConfig>>(parsedConfig: T) => {
  const result: AppConfig = {
    ...parsedConfig,
    identityUrl: normalizeSlashChars(parsedConfig.identityUrl, false, false),
    staticApiUrl: normalizeSlashChars(parsedConfig.staticApiUrl, false, false),
  };

  return result;
};

export const getConfiguration = (config: string) => {
  const parsedConfig = parseSpaConfig<ToIndexed<AppConfig>>(config, requiredProps);
  logDebug('parsed configuration', parsedConfig);
  const result = normalizeConfigData(parsedConfig);
  logInfo('normalized configuration', result);

  return result;
};
